import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$insuranceIdentifier/transactions")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello &ldquo;/dashboard/transactions&ldquo;!</div>;
}
